// src/index.react-server.ts
import { cookies as nextCookies, headers as nextHeaders } from "./next-static-analysis-workaround.js";
var isReactServer = true;
var cookies = nextCookies;
var headers = nextHeaders;
export {
  cookies,
  headers,
  isReactServer
};
//# sourceMappingURL=index.react-server.js.map